module.exports = __webpack_public_path__ + "static/learning_trips-956d9f51a578c61d97538cffff26c49e.png";